/**
* MIND CONTACT FORM
*
* @since      1.0
* @package    Mindfolio
* @subpackage Mind Contact Form
* @author     Webmajstr <info@webmajstr.cz>
* @copyright  Copyright (c) 2021 Webmajstr
* @license    GPL2+
*/

import WM_Subscribe_Form_Public from './inc/wm-subscribe-public';

window.addEventListener('load', () => {

	const wms_forms = document.querySelectorAll('.wm-subscribe-wrapper');
	
	wms_forms.forEach ( el_form  => {

		const html_el = el_form as HTMLDivElement;

		const WMS_Instance = new WM_Subscribe_Form_Public (html_el);
		WMS_Instance.init();

	});
});
